
import { toast } from 'sonner';
import { processUserContent } from '@/lib/security/content-security';
import { ZodError } from 'zod';

export function validatePaperInputs(
  title: string, 
  abstract: string, 
  authorId: string, 
  category: string
): boolean {
  try {
    if (!title?.trim()) {
      toast.error('Title is required');
      return false;
    }

    if (!abstract?.trim()) {
      toast.error('Abstract is required');
      return false;
    }

    if (!authorId) {
      toast.error('Author ID is required');
      return false;
    }

    if (!category?.trim()) {
      toast.error('Category is required');
      return false;
    }

    // Validate and sanitize content with specific error messages
    try {
      processUserContent.title(title);
    } catch (error) {
      if (error instanceof ZodError) {
        const issue = error.issues[0];
        if (issue.code === 'too_small') {
          toast.error(`Title must be at least ${(issue as any).minimum} characters`);
        } else if (issue.code === 'too_big') {
          toast.error(`Title must be less than ${(issue as any).maximum} characters`);
        } else {
          toast.error('Invalid title format');
        }
      } else {
        toast.error('Invalid title');
      }
      return false;
    }

    try {
      processUserContent.abstract(abstract);
    } catch (error) {
      if (error instanceof ZodError) {
        const issue = error.issues[0];
        if (issue.code === 'too_small') {
          toast.error(`Abstract must be at least ${(issue as any).minimum} characters`);
        } else if (issue.code === 'too_big') {
          toast.error(`Abstract must be less than ${(issue as any).maximum} characters`);
        } else {
          toast.error('Invalid abstract format');
        }
      } else {
        toast.error('Invalid abstract');
      }
      return false;
    }

    return true;
  } catch (error) {
    console.error('Paper input validation error:', error);
    toast.error('Invalid input data. Please check your submission.');
    return false;
  }
}
